import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Image,
  Spinner,
  Button,
  Nav,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import AuthNavBar from "./components/nav/AuthNav";
import { useSelector } from "react-redux";
import axios from "axios";
import { Link } from "react-router-dom";
import defaultUser from "../features/assets/default_user.png";
import { useTranslation } from "react-i18next";

const ViewDetails = () => {
  const { t } = useTranslation();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Assuming the token is stored in Redux
  const token = localStorage.getItem("token");
  const trackingID = localStorage.getItem("trackingIDFromServer");

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          `https://idms-preenrol.e-citizen.org/api/v1/enrolment/trackingId/${trackingID}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setUserData(response.data);
        setLoading(false);
      } catch (err) {
        setError(t("failed_fetch_user_data"));
        setLoading(false);
      }
    };

    fetchUserData();
  }, [token]);

  const renderContent = () => {
    if (loading) {
      return (
        <Container
          className="d-flex justify-content-center align-items-center"
          style={{ height: "calc(100vh - 56px)" }} // Adjust for navbar height
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">{t("loading")}</span>
          </Spinner>
        </Container>
      );
    }

    if (error) {
      return <div className="text-center mt-5">{error}</div>;
    }

    if (!userData) {
      return <div className="text-center mt-5">{t("no_user_data")}</div>;
    }

    return (
      <Container className="mt-5">
        <h1 className="mb-4 text-center fw-bold">{t("enrolment_details")}</h1>
        <Row>
          <Col md={4}>
            <Card className="shadow-lg rounded-4 border-0">
              <Card.Body className="text-center">
                <Image
                  src={
                    userData.photo
                      ? `data:image/jpeg;base64,${userData.photo}`
                      : defaultUser // Default Avatar
                  }
                  roundedCircle
                  width={150}
                  height={150}
                />
                <h3 className="mt-3">{`${userData.firstName} ${userData.lastName}`}</h3>

                <Row>
                  <Col>
                    <strong>{t("gender")}</strong>
                    <p>{userData.gender}</p>
                  </Col>
                  <Col>
                    <strong>{t("dob")}</strong>
                    <p>{userData.dob || "-"}</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <strong># {t("nui")}</strong>
                    <p className="text-info">{userData.nui || userData.UIN}</p>
                  </Col>
                  <Col>
                    <strong>{t("status")}</strong>
                    <p className="text-success">{userData.status}</p>
                  </Col>
                </Row>
                {userData.status === "PRE-ENROL" ? (
                  <Nav.Link
                    as={Link}
                    to={{
                      pathname: "/personal-modification",
                      state: { userData }, // Passing userData to the next page
                    }}
                  >
                    <Button variant="success" className="mb-2">
                      {t("edit_details")}
                    </Button>
                  </Nav.Link>
                ) : (
                  ""
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col md={8}>
            <Card
              className="shadow-lg rounded-4 border-0"
              style={{ marginTop: "20px" }}
            >
              <Card.Body>
                <h4> {t("personal_details")}</h4>
                <Row>
                  <Col md={6}>
                    <p>
                      <strong>{t("first_name")}</strong>
                      <br />
                      {userData.firstName}
                    </p>
                    <p>
                      <strong>{t("phone_number")}</strong>
                      <br />
                      {userData.phoneNumber}
                    </p>
                    <p>
                      <strong>{t("region")}</strong>
                      <br />
                      {userData.region}
                    </p>
                    <p>
                      <strong>{t("district")}</strong>
                      <br />
                      {userData.district}
                    </p>
                    <p>
                      <strong>{t("address")}</strong>
                      <br />
                      {userData.residenceAddress}
                    </p>
                    <p>
                      <strong>{t("maiden_name")}</strong>
                      <br />
                      {userData.maidenName}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong>{t("last_name")}</strong>
                      <br />
                      {userData.lastName}
                    </p>
                    <p>
                      <strong>{t("email_address")}</strong>
                      <br />
                      {userData.email}
                    </p>
                    <p>
                      <strong>{t("province")}</strong>
                      <br />
                      {userData.province}
                    </p>
                    <p>
                      <strong>{t("central_record_id")}</strong>
                      <br />
                      {userData.centralRecordId}
                    </p>
                    <p>
                      <strong>{t("contact_owner")}</strong>
                      <br />
                      {userData.contactOwner}
                    </p>
                    <p>
                      <strong>{t("place_of_birth")}</strong>
                      <br />
                      {userData.placeOfBirth || "Not provided"}
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  };

  return (
    <>
      <AuthNavBar />
      {renderContent()}
    </>
  );
};

export default ViewDetails;
